"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$putAccount = exports.$postUserPhoneBook = exports.$postAccount = exports.$patchUserPhoneBook = exports.$getUserPhoneBook = exports.$getAccounts = exports.$getAccountPhoneBook = exports.$getAccountByUsername = exports.$getAccount = exports.$deleteUserPhoneBook = exports.$deleteAccount = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/sip-accounts';
var $deleteAccount = id => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(id)
});
exports.$deleteAccount = $deleteAccount;
var $getAccount = id => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(id)
});
exports.$getAccount = $getAccount;
var $getAccounts = () => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base)
});
exports.$getAccounts = $getAccounts;
var $postAccount = body => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base),
  body
});
exports.$postAccount = $postAccount;
var $putAccount = (accountId, body) => (0, _oldHttpClient.apiClient)({
  method: 'put',
  url: "".concat(base, "/").concat(accountId),
  body
});
exports.$putAccount = $putAccount;
var $getAccountPhoneBook = (accountId, search) => (0, _oldHttpClient.getAxiosProvider)()({
  method: 'get',
  url: "".concat(base, "/").concat(accountId, "/phone-book"),
  params: {
    search
  }
});
exports.$getAccountPhoneBook = $getAccountPhoneBook;
var $getAccountByUsername = (accountId, username) => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(accountId, "/phone-book/").concat(username)
});
exports.$getAccountByUsername = $getAccountByUsername;
var $getUserPhoneBook = (accountId, contactId) => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(accountId, "/phone-book/external/").concat(contactId)
});
exports.$getUserPhoneBook = $getUserPhoneBook;
var $postUserPhoneBook = (accountId, body) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(accountId, "/phone-book/external"),
  body
});
exports.$postUserPhoneBook = $postUserPhoneBook;
var $patchUserPhoneBook = (accountId, contactId, body) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(accountId, "/phone-book/external/").concat(contactId),
  body
});
exports.$patchUserPhoneBook = $patchUserPhoneBook;
var $deleteUserPhoneBook = (accountId, contactId) => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(accountId, "/phone-book/external/").concat(contactId)
});
exports.$deleteUserPhoneBook = $deleteUserPhoneBook;